var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04423 8.43235C7.61286 9.48382 5.81727 10.2172 4.86825 11.1662C2.66825 13.3662 3.256 17.4319 5.52071 18.2137C7.60747 18.9255 5.63394 15.1402 7.60747 13.4956C9.69963 11.8941 15.0864 14.6926 10.7673 18.3431C9.75355 19.0873 9.60257 19.3353 8.94472 19.9931C5.40747 23.5304 11.1447 27.5368 15.3452 27.0245C19.0658 26.5716 20.0849 24.1289 20.6026 20.651C21.0717 17.4804 20.4408 16.375 20.9315 14.0725C22.5114 9.71029 27.6178 13.4255 28.3349 15.5392C28.3511 15.2966 28.3727 15.0593 28.3727 14.8113C28.3727 7.32696 22.3011 1.25 14.806 1.25C10.5138 1.25 6.6962 3.25049 4.2158 6.36176C7.07904 4.57696 8.93394 6.28088 8.04423 8.43235Z",
    fill: "url(#paint0_radial_3925_19919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7564 17.0289C20.7182 16.0715 20.6841 15.22 20.9314 14.0724C22.5113 9.71016 27.6123 13.4254 28.3402 15.5445C27.9627 22.6945 22.0637 28.3832 14.8113 28.3832C7.32157 28.3832 1.25 22.3062 1.25 14.8165C1.25 11.619 2.36078 8.68565 4.21569 6.36702C7.07892 4.57682 8.93382 6.28075 8.04412 8.43222C7.78462 9.06946 7.01486 9.59065 6.23828 10.1165C5.74006 10.4538 5.23903 10.793 4.86814 11.166C2.66814 13.366 3.25588 17.4317 5.52059 18.2136C6.58252 18.5758 6.59296 17.7734 6.60718 16.6812C6.6209 15.6271 6.63813 14.3031 7.60735 13.4955C9.69412 11.894 15.0863 14.6925 10.7672 18.343C9.98301 18.9186 9.71509 19.1974 9.32947 19.5986C9.21658 19.7161 9.09359 19.844 8.94461 19.993C5.40735 23.5303 11.1446 27.5366 15.3451 27.0244C19.0657 26.5714 20.0902 24.1342 20.6024 20.6508C20.8378 19.0632 20.795 17.9925 20.7564 17.0289ZM23.8753 10.0714C23.2498 10.945 21.6969 10.8803 20.3974 9.94741C19.1033 9.00918 18.5587 7.54251 19.1788 6.67437C19.8042 5.80624 21.368 5.86555 22.6621 6.80918C23.9562 7.73663 24.5062 9.20329 23.8753 10.0714Z",
    fill: "url(#paint1_radial_3925_19919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3925_19919",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0017 8.95472) scale(18.0169 18.6936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF402F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2057,
    stopColor: "#E0382B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5402,
    stopColor: "#C42225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BE1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1113"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3925_19919",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3844 8.19836) scale(17.5782 14.7726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9297"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/유진투자증권-30.51f8cdaa5f5f4b20dd458c95f3bbfc00.svg";
export { ForwardRef as ReactComponent };